import { useLocale } from "@/contexts/IntlContext";
import { FormattedMessage } from "react-intl";

interface SubtitleLanguageSwitcherProps {
  subtitleLanguage: "ar" | "en";
  onLanguageChange: (language: "ar" | "en") => void;
  labelMessageId?: string;
  labelDefaultMessage?: string;
}

export default function SubtitleLanguageSwitcher({
  subtitleLanguage,
  onLanguageChange,
  labelMessageId = "exercise.subtitles",
  labelDefaultMessage = "Subtitles:",
}: SubtitleLanguageSwitcherProps) {
  const { locale } = useLocale();
  const isRTL = locale === "ar";

  return (
    <div className="flex pb-3">
      <div className="inline-flex items-center gap-3">
        <div className="flex items-center">
          <span className="text-xs text-foreground">
            <FormattedMessage
              id={labelMessageId}
              defaultMessage={labelDefaultMessage}
            />
          </span>
        </div>
        <div className="relative inline-flex items-center bg-muted rounded-full transition-all shadow-inner">
          {(["en", "ar"] as const).map((lang) => (
            <button
              key={lang}
              onClick={() => onLanguageChange(lang)}
              className={`relative z-10 px-3.5 py-2 text-xs rounded-full transition-all duration-300 ${
                subtitleLanguage === lang
                  ? "text-primary-foreground"
                  : "text-muted-foreground"
              }`}
            >
              {lang === "en" ? "English" : "العربية"}
            </button>
          ))}

          <span
            className={`absolute top-1 left-1 h-[calc(100%-0.5rem)] w-[calc(50%-0.25rem)] bg-primary rounded-full transition-all duration-300 ease-in-out ${
              isRTL
                ? subtitleLanguage === "en"
                  ? "translate-x-full"
                  : "translate-x-0"
                : subtitleLanguage === "ar"
                  ? "translate-x-full"
                  : "translate-x-0"
            }`}
          />
        </div>
      </div>
    </div>
  );
}
